import headers from 'utils/api/lib/headers';

export const fetchWithHeaders = (r, i) =>
  fetch(r, { ...i, headers: headers() });
